module.exports = __webpack_public_path__ + "img/spike-protein-beta.9019d55b.png";